
export default function MissionVision() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-6">
              <i className="ri-target-line text-3xl text-red-600"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Mission</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              To provide high-quality, QCDD-approved fire safety systems and services that ensure 
              safety, reliability, and peace of mind for our clients across Qatar.
            </p>
            <div className="mt-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20fire%20alarm%20control%20panel%20with%20digital%20display%20showing%20system%20status%2C%20red%20LED%20indicators%2C%20professional%20fire%20safety%20equipment%20in%20Qatar%20building%2C%20clean%20technical%20environment%20with%20safety%20compliance%20certificates&width=400&height=250&seq=mission-img&orientation=landscape"
                alt="Fire Safety Systems"
                className="rounded-xl object-cover w-full h-48"
              />
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-6">
              <i className="ri-eye-line text-3xl text-red-600"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Vision</h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              To be Qatar's most trusted and innovative partner in fire protection and life safety solutions.
            </p>
            <div className="mt-6">
              <img 
                src="https://readdy.ai/api/search-image?query=Qatar%20skyline%20with%20modern%20buildings%20featuring%20advanced%20fire%20safety%20systems%2C%20fire%20sprinkler%20heads%20and%20emergency%20lighting%20visible%2C%20professional%20fire%20protection%20infrastructure%2C%20clean%20architectural%20design%20with%20safety%20focus&width=400&height=250&seq=vision-img&orientation=landscape"
                alt="Qatar Fire Safety Infrastructure"
                className="rounded-xl object-cover w-full h-48"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}